import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 264 107",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"68\" y=\"59\" width=\"108\" height=\"8\" rx=\"4\" fill=\"var(--dt-color-surface-moderate)\" id=\"line-3\"></rect><rect x=\"68\" y=\"75\" width=\"64\" height=\"8\" rx=\"4\" fill=\"var(--dt-color-surface-moderate)\" id=\"line-2\"></rect><rect x=\"68\" y=\"43\" width=\"128\" height=\"8\" rx=\"4\" fill=\"var(--dt-color-surface-moderate)\" id=\"line-1\"></rect><rect x=\"88\" y=\"23\" width=\"108\" height=\"12\" rx=\"6\" fill=\"var(--dt-color-foreground-placeholder)\" id=\"title-line\"></rect><path d=\"M68 26L73 31L78 26\" stroke=\"var(--dt-color-foreground-placeholder)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"arrow-down\"></path>", 5)
  ]))]))
}
export default { render: render }